import { TDeviceType } from '@cian/ui-kit';
import { sendCaEvent } from '../sendCaEvent';
import { getSiteType } from '../getSiteType';

export function sendCareerNavigationEvent(path: string, deviceType: TDeviceType) {
  sendCaEvent({
    name: 'oldevent',
    category: 'Career',
    action: 'Click',
    label: path,
    page: { siteType: getSiteType(deviceType), pageType: 'Career' },
  });
}
